mutation updateInvite($custom_invite: String, $uuid: String, $language: String, $custom_text: String, $disabled: Boolean) {
    updateInvite(custom_invite: $custom_invite, uuid: $uuid, language: $language, custom_text: $custom_text, disabled: $disabled) {
        custom_invite
        uuid
        language
        custom_text
        disabled
    }
}
